import {
  Button,
  Col,
  Collapse,
  Form,
  Input,
  Popover,
  Radio,
  Row,
  Select,
} from "antd";
import { Field, Formik } from "formik";
import React, { Fragment, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { DatePicker, InputNumber } from "antd";
import dayjs from "dayjs";
import { convertObject } from "../../../common/Utilities";
import { COE_Category, CustomerIDType, Vehicle_emission_scheme } from "../../../common/Constants";
import { useSelector } from "react-redux";
import axios from "../../../axios/axios";

const VehicleEdit = ({ editType, editData, vehicleCategory, opcData }) => {
  const [settings, setSettings] = useState({});
  const [vehicleDetail, setVehicleDetail] = useState({});
  const [validationDetails, setValidationDetails] = useState({});
  const [vehicleLoanTypeData, setVehicleLoanTypeData] =
    useState(vehicleCategory);
  const handleBlur = (e, formikProps) => {
    let updateData = formikProps.values;
    const { name, value } = e.target;
    formikProps.setFieldValue(name, value);
    formikProps.setFieldTouched(name, true);
    setVehicleDetail(formikProps.values);
    updateData = convertObject(formikProps.values);
    setValidationDetails(updateData);
    localStorage.setItem("vehicleDetails", JSON.stringify(updateData));
  };

  console.log("settings", settings);

  const handleChange = (e, formikProps) => {
    const { name, value } = e.target;
    let data = { ...formikProps.values };
    if (name == "opc_vehicle_id" && value == 0) {
      data["is_opc_car"] = 0;
      data["opc_vehicle_id"] = 0;
    } else if (name == "opc_vehicle_id" && value != 0) {
      data["is_opc_car"] = 1;
      data["opc_vehicle_id"] = value;
    }
    console.log(data);
    if (name == "vehicle_under_opc") {
      data["vehicle_under_opc"] = value;
      console.log(data);
    }
    let updateData = data;
    updateData = convertObject(data);
    if (updateData["vehicle_under_opc"] != undefined) {
      if (updateData["vehicle_under_opc"]["value"] == 0) {
        updateData["vehicle_under_opc"]["validation"] = true;
      }
    }
    if (updateData["opc_vehicle_id"] != undefined) {
      if (updateData["opc_vehicle_id"]["value"] == 0) {
        updateData["opc_vehicle_id"]["validation"] = true;
        updateData["is_opc_car"]["validation"] = true;
      }
    }
    setVehicleDetail(data);
    setValidationDetails(updateData);
    localStorage.setItem("vehicleDetails", JSON.stringify(updateData));
  };
  const handleDropdownChange = (name, value, formikProps) => {
    let data = { ...vehicleDetail };
    formikProps.setFieldValue(name, value);
    formikProps.setFieldTouched(name, true);
    data[name] = value;
    setVehicleDetail(data);
    let updateData = data;
    updateData = convertObject(data);
    setValidationDetails(updateData);
    localStorage.setItem("vehicleDetails", JSON.stringify(updateData));
  };

  useEffect(() => {
    if (editType == "Vehicle") {
      console.log(editData);
      let finalEditData = { ...editData };
      finalEditData["vehicle_under_opc"] = Number(
        finalEditData.vehicle_under_opc
      );
      let updateData = convertObject(finalEditData);
      console.log(updateData);
      localStorage.setItem("vehicleDetails", JSON.stringify(updateData));
      setVehicleDetail(finalEditData);
    }
  }, []);

  useEffect(() => {
    async function GetSettings() {
      let res = await axios.get("/settings");
      setSettings(res.data?.data);
    }
    GetSettings();
  }, []);
  return (
    <div>
      <Formik enableReinitialize={true} initialValues={vehicleDetail}>
        {(formikProps) => (
          <Form>
            <div className="input-one-line-dealer">
              <div className="input-group w-full md:w-[230px]">
                <label>Vehicle Reg No</label>
                <Form.Item className="mt-1">
                  <Field name="vehicle_reg_no">
                    {({ field }) => (
                      <Input
                        {...field}
                        onBlur={(e) => handleBlur(e, formikProps)}
                      />
                    )}
                  </Field>
                  {validationDetails?.vehicle_reg_no?.validation == false && (
                    <span className="error">Vehicle Regno Required</span>
                  )}
                </Form.Item>
              </div>
              <div className="input-group w-full md:w-[230px]">
                <label>Customer ID Type</label>
                {console.log("VECHFORM", settings?.ownerid_types, vehicleDetail.customer_id_type)}
                <Form.Item className="w-full mt-1">
                  <Field name="customer_id_type">
                    {({ field }) => (
                      <Select
                        {...field}
                        name="customer_id_type"
                        onChange={(e) => {
                          handleDropdownChange(
                            "customer_id_type",
                            e,
                            formikProps
                          );
                        }}
                        options={settings?.ownerid_types}
                        value={Number(vehicleDetail.customer_id_type)}
                      />
                    )}
                  </Field>
                  {validationDetails?.customer_id_type?.validation == false && (
                    <span className="error">Customer ID Type Required</span>
                  )}
                </Form.Item>
              </div>
              <div className="input-group w-full md:w-[230px]">
                <label>Owner ID Last 4 Charcters</label>
                <Form.Item className="mt-1">
                  <Field name="owner_id">
                    {({ field }) => (
                      <Input
                        {...field}
                        maxLength={4}
                        onBlur={(e) => handleBlur(e, formikProps)}
                      />
                    )}
                  </Field>
                  {validationDetails?.owner_id?.validation == false && (
                    <span className="error">Owner ID Required</span>
                  )}
                </Form.Item>
              </div>
              <div className="input-group w-full md:w-[230px]">
                <label>Make/Model</label>
                <Form.Item className="mt-1">
                  <Field name="make_model">
                    {({ field }) => (
                      <Input
                        {...field}
                        onBlur={(e) => handleBlur(e, formikProps)}
                      />
                    )}
                  </Field>
                  {validationDetails?.make_model?.validation == false && (
                    <span className="error">Make Model Required</span>
                  )}
                </Form.Item>
              </div>
            </div>
            <div className="input-one-line-dealer">
              <div className="input-group w-full md:w-[230px]">
                <label>Is this an OPC Vehicle?</label>
                <Form.Item className="mt-1">
                  <Field name="opc_vehicle_id">
                    {({ field }) => (
                      <Radio.Group
                        {...field}
                        onChange={(e) => handleChange(e, formikProps)}
                        value={field.value === null ? 0 : field.value}
                      >
                        <Radio key={0} value={0}>
                          <p>No</p>
                        </Radio>
                        {opcData != undefined &&
                          opcData.length > 0 &&
                          opcData.map((data) => {
                            return (
                              <Radio key={data.id} value={data.id}>
                                <p>{data.title}</p>
                              </Radio>
                            );
                          })}
                      </Radio.Group>
                    )}
                  </Field>
                  <br />
                  {validationDetails?.opc_vehicle_id?.validation == false &&
                    validationDetails?.opc_vehicle_id == "" && (
                      <span className="error">OPC Vehicle Type Required</span>
                    )}
                </Form.Item>
              </div>
            </div>
            {vehicleLoanTypeData == "New" && editType == "Vehicle" && (
              <Fragment>
                <div className="input-one-line-dealer">
                  <div className="input-group w-full md:w-[230px]">
                    <label>Y.O.M</label>
                    <Form.Item className="mt-1">
                      <Field name="vehicle_yom">
                        {({ field }) => (
                          <Input
                            {...field}
                            onBlur={(e) => handleBlur(e, formikProps)}
                          />
                        )}
                      </Field>
                      {validationDetails?.vehicle_yom?.validation == false && (
                        <span className="error">Vehicle YOM Required</span>
                      )}
                    </Form.Item>
                  </div>
                  <div className="input-group w-full md:w-[230px]">
                    <label>Purchase Price</label>
                    <Form.Item className="w-full mt-1">
                      <Field name="vehicle_purchase_price">
                        {({ field }) => (
                          <Input
                            {...field}
                            onBlur={(e) => handleBlur(e, formikProps)}
                          />
                        )}
                      </Field>
                      {validationDetails?.vehicle_purchase_price?.validation ==
                        false && (
                          <span className="error">
                            Vehicle Purchase Price Required
                          </span>
                        )}
                    </Form.Item>
                  </div>
                  <div className="input-group w-full md:w-[230px]">
                    <label>OMV</label>
                    <Form.Item className="mt-1">
                      <Field name="vehicle_omv">
                        {({ field }) => (
                          <Input
                            {...field}
                            onBlur={(e) => handleBlur(e, formikProps)}
                          />
                        )}
                      </Field>
                      {validationDetails?.vehicle_omv?.validation == false && (
                        <span className="error">OMV Required</span>
                      )}
                    </Form.Item>
                  </div>
                </div>
                <div className="input-one-line-dealer">
                  <div className="input-group w-full md:w-[230px]">
                    <label>Engine No</label>
                    <Form.Item className="mt-1">
                      <Field name="vehicle_engine_no">
                        {({ field }) => (
                          <Input
                            {...field}
                            onBlur={(e) => handleBlur(e, formikProps)}
                          />
                        )}
                      </Field>
                      {validationDetails?.vehicle_engine_no?.validation ==
                        false && (
                          <span className="error">
                            Vehicle Engine No Required
                          </span>
                        )}
                    </Form.Item>
                  </div>
                  <div className="input-group w-full md:w-[230px]">
                    <label>Chassis No</label>
                    <Form.Item className="w-full mt-1">
                      <Field name="vehicle_chassis_no">
                        {({ field }) => (
                          <Input
                            {...field}
                            onBlur={(e) => handleBlur(e, formikProps)}
                          />
                        )}
                      </Field>
                      {validationDetails?.vehicle_chassis_no?.validation ==
                        false && (
                          <span className="error">
                            Vehicle Chassis No Required
                          </span>
                        )}
                    </Form.Item>
                  </div>
                  <div className="input-group w-full md:w-[230px]">
                    <label>Ori.Reg Date (Overseas)</label>
                    <Form.Item className="mt-1">
                      <Field name="vehicle_ori_reg_date">
                        {({ field }) => (
                          <DatePicker
                            className="w-full"
                            allowClear={false}
                            format="DD-MM-YYYY"
                            {...field}
                            value={
                              vehicleDetail.vehicle_ori_reg_date
                                ? dayjs(vehicleDetail.vehicle_ori_reg_date)
                                : ""
                            }
                            name="vehicle_ori_reg_date"
                            onChange={(date) => {
                              handleDropdownChange(
                                "vehicle_ori_reg_date",
                                dayjs(date).format("YYYY-MM-DD"),
                                formikProps
                              );
                            }}
                          />
                        )}
                      </Field>
                      {validationDetails?.vehicle_ori_reg_date?.validation ==
                        false && (
                          <span className="error">Vehicle Reg Date Required</span>
                        )}
                    </Form.Item>
                  </div>
                </div>
                <div className="input-one-line-dealer">
                  <div className="input-group w-full md:w-[230px]">
                    <label>COE Amount</label>
                    <Form.Item className="mt-1">
                      <Field name="vehicle_coe_amount">
                        {({ field }) => (
                          <Input
                            {...field}
                            onBlur={(e) => handleBlur(e, formikProps)}
                          />
                        )}
                      </Field>
                      {validationDetails?.vehicle_coe_amount?.validation ==
                        false && (
                          <span className="error">COE Amount Required</span>
                        )}
                    </Form.Item>
                  </div>
                  <div className="input-group w-full md:w-[230px]">
                    <label>COE Category</label>
                    <Form.Item className='w-full mt-1'>
                      <Field name="vehicle_coe_category">
                        {({ field }) => (
                          <Select
                            {...field}
                            name="vehicle_coe_category"
                            onChange={(e) => { handleDropdownChange('vehicle_coe_category', e, formikProps) }}
                            options={COE_Category}
                            value={vehicleDetail.vehicle_coe_category}

                          />
                        )}
                      </Field>
                      {validationDetails?.vehicle_coe_category?.validation == false &&
                        <span className='error'>Vehicle COE Category Required</span>
                      }
                    </Form.Item>
                  </div>
                  <div className="input-group w-full md:w-[230px]">
                    <label>Vehicle Emission Scheme(VES)</label>
                    <Form.Item className='mt-1'>
                      <Field name="vehicle_emission_scheme">
                        {({ field }) => (
                          <Select
                            {...field}
                            name="vehicle_emission_scheme"
                            onChange={(e) => { handleDropdownChange('vehicle_emission_scheme', e, formikProps) }}
                            options={Vehicle_emission_scheme}
                            value={vehicleDetail.vehicle_emission_scheme}

                          />
                        )}
                      </Field>
                      {validationDetails?.vehicle_emission_scheme?.validation == false &&
                        <span className='error'>Vehicle Emission Scheme Required</span>
                      }
                    </Form.Item>
                  </div>
                </div>
                <div className="input-one-line-dealer">
                  <div className="input-group w-full md:w-[230px]">
                    <label>COE-QP / PQP Paid</label>
                    <Form.Item className="mt-1">
                      <Field name='parf_rebate'>
                        {({ field }) => (
                          <Input
                            {...field}
                            onBlur={(e) => handleBlur(e, formikProps)}
                          />
                        )}
                      </Field>
                    </Form.Item>
                  </div>
                  <div className="input-group w-full md:w-[230px]">
                    <label>COE Rebate</label>
                    <Form.Item className='w-full mt-1'>
                      <Field name='coe_rebate'>
                        {({ field }) => (
                          <Input
                            {...field}
                            onBlur={(e) => handleBlur(e, formikProps)}
                          />
                        )}
                      </Field>
                    </Form.Item>
                  </div>
                  <div className="input-group w-full md:w-[230px]">
                    <label>Total Rebate</label>
                    <Form.Item className='mt-1'>
                      <Field name='total_rebate'>
                        {({ field }) => (
                          <Input
                            {...field}
                            onBlur={(e) => handleBlur(e, formikProps)}
                          />
                        )}
                      </Field>
                    </Form.Item>
                  </div>
                </div>
                <div className="input-one-line-dealer">
                  <div className="input-group w-full md:w-[230px]">
                    <label>Will This Vehicle be Registered under OPC?</label>
                    <Form.Item className="mt-1">
                      <Field name="vehicle_under_opc">
                        {({ field }) => (
                          <Radio.Group
                            {...field}
                            onChange={(e) => handleChange(e, formikProps)}
                          >
                            <Radio key={0} value={0}>
                              <p>No</p>
                            </Radio>
                            <Radio key={1} value={1}>
                              <p>Yes</p>
                            </Radio>
                          </Radio.Group>
                        )}
                      </Field>
                      <br />
                      {validationDetails?.vehicle_under_opc?.validation ==
                        false &&
                        validationDetails?.vehicle_under_opc == "" && (
                          <span className="error">OPC Vehicle Required</span>
                        )}
                    </Form.Item>
                  </div>
                </div>
              </Fragment>
            )}
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default VehicleEdit;
